import Hidden from '@material-ui/core/Hidden';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';
import TimeChip from './TimeChip';

const useStyles = makeStyles(theme => ({
    billableHoursCell: {
        width: 60,
        paddingRight: 0,
    },
    totalHoursCell: {
        width: 60,
    },
}));

type Props = {
    totalTime : {
        total : number;
        billable : number;
        nonBillable : number;
    };
};

const TimeEntryTotalsRow : React.FC<Props> = ({totalTime} : Props) => {
    const classes = useStyles();

    return (
        <TableRow>
            <TableCell>Total</TableCell>
            <Hidden smDown>
                <TableCell/>
                <TableCell/>
                <TableCell/>
            </Hidden>
            <TableCell className={classes.billableHoursCell}>
                <TimeChip minutes={totalTime.billable} billable={true}/>
            </TableCell>
            <TableCell className={classes.totalHoursCell}>
                <TimeChip minutes={totalTime.total} billable={false}/>
            </TableCell>
            <TableCell/>
        </TableRow>
    );
};

export default TimeEntryTotalsRow;
